import { render } from "./MdButtonContent.vue?vue&type=template&id=25f1dc68"
import script from "./MdButtonContent.vue?vue&type=script&lang=js"
export * from "./MdButtonContent.vue?vue&type=script&lang=js"

import "./MdButtonContent.vue?vue&type=style&index=0&id=25f1dc68&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__